import { render, staticRenderFns } from "./ChangePlayerPositionNotification.vue?vue&type=template&id=3dd39e53&scoped=true&"
import script from "./ChangePlayerPositionNotification.vue?vue&type=script&lang=js&"
export * from "./ChangePlayerPositionNotification.vue?vue&type=script&lang=js&"
import style0 from "./ChangePlayerPositionNotification.vue?vue&type=style&index=0&id=3dd39e53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd39e53",
  null
  
)

export default component.exports